import React from "react";

import { withFilterCars } from "../../../shared/containers/containerFilterCars";

import FormHorisontItem from "./../../../shared/items/static/formHorisontItem";
import Checkbox from "./../../../shared/items/contols/checkbox";
import FilterCarsItems  from "./static.filterCarsItems";

const CarsSensorFilter = (props) => {
  const { onHandleChangeStore, filterCarsListItems } = props;

  return (
    <React.Fragment>
      <FormHorisontItem title={FilterCarsItems.sensorFuel.title}>
        <Checkbox name={FilterCarsItems.sensorFuel.name} valueStore={filterCarsListItems} handleChange={onHandleChangeStore} />
      </FormHorisontItem>

      <FormHorisontItem title={FilterCarsItems.sensorFlowMeter.title}>
        <Checkbox name={FilterCarsItems.sensorFlowMeter.name} valueStore={filterCarsListItems} handleChange={onHandleChangeStore} />
      </FormHorisontItem>

      <FormHorisontItem title={FilterCarsItems.sensorEquipment.title}>
        <Checkbox name={FilterCarsItems.sensorEquipment.name} valueStore={filterCarsListItems} handleChange={onHandleChangeStore} />
      </FormHorisontItem>

      <FormHorisontItem title={FilterCarsItems.sensorSand.title}>
        <Checkbox name={FilterCarsItems.sensorSand.name} valueStore={filterCarsListItems} handleChange={onHandleChangeStore} />
      </FormHorisontItem>

      <FormHorisontItem title={FilterCarsItems.sensorDump.title}>
        <Checkbox name={FilterCarsItems.sensorDump.name} valueStore={filterCarsListItems} handleChange={onHandleChangeStore} />
      </FormHorisontItem>

      <FormHorisontItem title={FilterCarsItems.sensorVideo.title}>
        <Checkbox name={FilterCarsItems.sensorVideo.name} valueStore={filterCarsListItems} handleChange={onHandleChangeStore} />
      </FormHorisontItem>

      <FormHorisontItem title={FilterCarsItems.sensorTemperature.title}>
        <Checkbox name={FilterCarsItems.sensorTemperature.name} valueStore={filterCarsListItems} handleChange={onHandleChangeStore} />
      </FormHorisontItem>

      <FormHorisontItem title={FilterCarsItems.sensorDistance.title}>
        <Checkbox name={FilterCarsItems.sensorDistance.name} valueStore={filterCarsListItems} handleChange={onHandleChangeStore} />
      </FormHorisontItem>
    </React.Fragment>
  );
};

export default withFilterCars(React.memo(CarsSensorFilter));
